import { useState, useEffect } from 'react';

type OnlineStatus = { isOnline: boolean };

let setOnlineGlobal: ((val: boolean) => void) | null = null;

export function setOnlineStatus(val: boolean) {
    setOnlineGlobal?.(val);
}

export function useOnlineStatus(): OnlineStatus {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        setOnlineGlobal = setIsOnline;

        const handleOnline  = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        const handleVisibility = () => {
            if (document.visibilityState === 'visible') setIsOnline(navigator.onLine);
        };

        window.addEventListener('online',  handleOnline);
        window.addEventListener('offline', handleOffline);
        document.addEventListener('visibilitychange', handleVisibility);

        return () => {
            setOnlineGlobal = null;
            window.removeEventListener('online',  handleOnline);
            window.removeEventListener('offline', handleOffline);
            document.removeEventListener('visibilitychange', handleVisibility);
        };
    }, []);

    return { isOnline };
}